import React, { useState } from "react";
import ThongTinLichSu from "../LichSuDuyetTatToan/ThongTinLichSu";
export const BtnLichSuTatToan = ({ item }) => {
    
    const [isModalVisible, setModalVisible] = useState(false);
    const setModalLichSuShow = () => {
        setModalVisible(!isModalVisible);
    }
    return (
        <>
            <a onClick={setModalLichSuShow} href={() => false} className="blue btn-link" title="Lịch sử duyệt tất toán">
                <i className="mdi mdi-history"></i>
            </a>
            {isModalVisible && (
                <ThongTinLichSu
                    show={isModalVisible}
                    onHide={setModalLichSuShow}
                    item={item}
                ></ThongTinLichSu>
            )}
        </>
    );
};
